import { AllowInElement } from '@ngneat/hotkeys';

// prettier-ignore
export const allAllowInElements = ["INPUT", "SELECT", "TEXTAREA", "CONTENTEDITABLE"] as AllowInElement[];
